import React from 'react';
import { CTAButton } from './CTAButton';
import { ZapIcon } from 'lucide-react';
export function PersuasiveCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return;
}